var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlag4 = function SvgFlag4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 4.333h4.137c.286 0 .429 0 .515.06a.33.33 0 0 1 .138.225c.016.104-.048.232-.176.487l-.835 1.67c-.041.083-.062.124-.07.167a.3.3 0 0 0-.003.117.7.7 0 0 0 .063.171l.898 2.02c.11.25.166.375.148.476a.33.33 0 0 1-.14.216c-.085.058-.222.058-.496.058H8.067c-.374 0-.56 0-.703-.073a.67.67 0 0 1-.291-.291C7 9.493 7 9.306 7 8.933v-1.6M2 14V2.333m0 5h5.933c.374 0 .56 0 .703-.072a.67.67 0 0 0 .291-.292C9 6.827 9 6.64 9 6.267V2.733c0-.373 0-.56-.073-.702a.67.67 0 0 0-.291-.292c-.143-.072-.33-.072-.703-.072H3.067c-.374 0-.56 0-.703.072a.67.67 0 0 0-.291.292C2 2.173 2 2.36 2 2.733z"
  })));
};
export default SvgFlag4;